var _excluded = ["children", "width", "header", "footer", "maxHeight", "dropdownTestId"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { FloatingFocusManager, FloatingList, useMergeRefs } from '@floating-ui/react';
import React from 'react';
import { Box, Portal } from '../../../components/internal';
import { forwardRef } from '../../../utils';
import { useMultiStyleConfig } from '../../../utils/use-style-config';
import { Group } from '../../Group';
import { useBaseMenuContext } from '../hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var Dropdown = forwardRef((_ref, propRef) => {
  var {
    children,
    width,
    header,
    footer,
    maxHeight,
    dropdownTestId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var {
    refs,
    elementsRef,
    labelsRef,
    getFloatingProps,
    x,
    y,
    strategy,
    isOpen,
    context
  } = useBaseMenuContext();
  var ref = useMergeRefs([refs.setFloating, propRef]);
  var styles = useMultiStyleConfig('BaseMenu', {
    width,
    maxHeight,
    position: strategy,
    top: y,
    left: x
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: isOpen && /*#__PURE__*/_jsx(Portal, {
      children: /*#__PURE__*/_jsx(FloatingFocusManager, {
        context: context,
        modal: false,
        children: /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
          ref: ref,
          __css: styles['dropdown'],
          "data-testid": dropdownTestId !== null && dropdownTestId !== void 0 ? dropdownTestId : 'base-menu-dropdown'
        }, getFloatingProps(_objectSpread(_objectSpread({}, props), {}, {
          onKeyDown: e => {
            e.stopPropagation();
          }
        }))), {}, {
          children: /*#__PURE__*/_jsx(FloatingList, {
            elementsRef: elementsRef,
            labelsRef: labelsRef,
            children: React.Children.count(children) ? /*#__PURE__*/_jsxs(Group, {
              variant: "vertical",
              spacing: "none",
              hasDivider: true,
              children: [/*#__PURE__*/_jsxs(Group, {
                variant: "vertical",
                spacing: "none",
                children: [header, /*#__PURE__*/_jsx(Box, {
                  __css: styles['content'],
                  children: children
                })]
              }), footer]
            }) : footer
          })
        }))
      })
    })
  });
});
//# sourceMappingURL=Dropdown.js.map